import { LocalStorageKeys } from '@app/core/storage';
import { useStore, LocalStore } from '@app/core/store';
const LOCAL_STORAGE_USER_KEY = LocalStorageKeys.User;
class UserStore extends LocalStore {
}
export const userStoreInstance = new UserStore(LOCAL_STORAGE_USER_KEY);
export const useUserStore = () => useStore(userStoreInstance);
